import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "top-action-bar" }
const _hoisted_2 = { class: "list-tabs-container" }
const _hoisted_3 = { class: "game-list-wrapper" }
const _hoisted_4 = { class: "game_left" }
const _hoisted_5 = { class: "game_center" }
const _hoisted_6 = { class: "game-title" }
const _hoisted_7 = { class: "meta-tags" }
const _hoisted_8 = { class: "create-time" }
const _hoisted_9 = { class: "game-desc" }
const _hoisted_10 = { class: "game_right" }
const _hoisted_11 = { class: "update-tip-box" }
const _hoisted_12 = {
  key: 0,
  class: "update-time"
}
const _hoisted_13 = { class: "btn-group" }
const _hoisted_14 = { class: "page-pagination" }
const _hoisted_15 = { class: "game-list-wrapper" }
const _hoisted_16 = { class: "game_left" }
const _hoisted_17 = { class: "game_center" }
const _hoisted_18 = { class: "game-title" }
const _hoisted_19 = { class: "meta-tags" }
const _hoisted_20 = { class: "create-time" }
const _hoisted_21 = { class: "game-desc" }
const _hoisted_22 = { class: "game_right" }
const _hoisted_23 = { class: "update-tip-box" }
const _hoisted_24 = {
  key: 0,
  class: "days-left"
}
const _hoisted_25 = { class: "highlight-days" }
const _hoisted_26 = { class: "btn-group" }
const _hoisted_27 = { class: "page-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back(-1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("List.button1")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "home-btn",
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("List.button2")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        "tab-position": _ctx.tabPosition,
        class: "modern-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('List.creationList')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "game-card animate-card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_image, {
                        src: item.gameCover,
                        fit: "cover",
                        class: "cover-img"
                      }, {
                        placeholder: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("div", { class: "image-slot-placeholder" }, "加载中...", -1)
                        ]))]),
                        _: 1
                      }, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", _hoisted_6, _toDisplayString(item.gameTitle || "未命名游戏"), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: "info",
                          effect: "plain",
                          class: "meta-tag-id"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" ID: " + _toDisplayString(item.id), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (item.gameLanguage)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "small",
                              type: "success",
                              effect: "light"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.gameLanguage), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: "warning",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.publicStatus == 0
                      ? "内测"
                      : item.publicStatus == 1
                      ? "正式上线"
                      : "公测"), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "region-span" }, "不限地区 — 任何地点", -1))
                      ]),
                      _createElementVNode("p", _hoisted_8, "建立于：" + _toDisplayString(item.createTime), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..."), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (item.updateTime)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("List.tip")) + _toDisplayString(item.updateTime), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "default",
                          class: "action-btn edit-btn",
                          onClick: ($event: any) => (_ctx.editGame(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("List.button3")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          plain: "",
                          size: "default",
                          class: "action-btn delete-btn",
                          onClick: ($event: any) => (_ctx.deleteGame(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("List.button4")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next",
                  total: _ctx.gamesTotal,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('List.trashCan')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.junkGameList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "game-card junk-card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_image, {
                        src: item.gameCover,
                        fit: "cover",
                        class: "cover-img"
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h3", _hoisted_18, _toDisplayString(item.gameTitle || "未命名游戏"), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: "info",
                          effect: "plain",
                          class: "meta-tag-id"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" ID: " + _toDisplayString(item.id), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (item.gameLanguage)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "small",
                              type: "success",
                              effect: "light"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.gameLanguage), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "region-span" }, "不限地区 — 任何地点", -1))
                      ]),
                      _createElementVNode("p", _hoisted_20, "建立于：" + _toDisplayString(item.createTime), 1),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..."), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        (item.deleteTime)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _cache[5] || (_cache[5] = _createTextVNode(" 剩余保留：", -1)),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getDaysDifference(item.deleteTime)), 1),
                              _cache[6] || (_cache[6] = _createTextVNode(" 天 ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_el_button, {
                          type: "success",
                          size: "default",
                          class: "action-btn restore-btn",
                          onClick: ($event: any) => (_ctx.restore(item.id))
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" 还原 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          plain: "",
                          size: "default",
                          class: "action-btn hard-delete-btn",
                          onClick: ($event: any) => (_ctx.completeDelete(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("List.button4")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next",
                  total: _ctx.junkGameListTotal,
                  onCurrentChange: _ctx.handleCurrentChange2
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["tab-position"])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}